// import cloudOff from "../../assets/svg/cloud-off.svg";
import {useEffect, useState} from "react";
import cloudOn from "../../../assets/svg/cloud-on.svg";
import cloudOff from "../../../assets/svg/cloud-off.svg";
import momentJalaali from "moment-jalaali";
import CachedIcon from "@mui/icons-material/Cached";

export const CloudIComponents = ({isUpdate}) => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [lastUpdate, setLastUpdate] = useState("");
    useEffect(() => {
        function onlineHandler() {
            setIsOnline(true);
        }

        function offlineHandler() {
            setIsOnline(false);
            const now = momentJalaali().format("HH:mm");
            setLastUpdate(now);
        }

        window.addEventListener("online", onlineHandler);
        window.addEventListener("offline", offlineHandler);

        return () => {
            window.removeEventListener("online", onlineHandler);
            window.removeEventListener("offline", offlineHandler);
        };
    }, []);

    return (
        <div className="mr-6">
            {isUpdate ? (
                <div
                    className="w-10 group ease-in duration-500 h-10 px-2 bg-[#F4F4F4] rounded-lg flex items-center justify hover:w-32">
                    {/* <img className="animate-spin" src={iconLoadingHeader} alt="loading" /> */}
                    <CachedIcon
                        className="animate-spin"
                        sx={{
                            width: "24px",
                            height: "24px",
                            color: "#707182",
                        }}
                    />
                    <div
                        className="hidden group-hover:flex transition-all overflow-hidden w-0 group-hover:flex-1 text-sm text-[#8D8E8F] mx-2">
                        بروزرسانی...
                    </div>
                </div>
            ) : (
                <div
                    className={`w-10 group ease-in duration-500 h-10 px-2 bg-[#F4F4F4] rounded-lg flex items-center justify ${
                        isOnline ? "hover:w-[88px]" : "hover:w-48"
                    }`}
                >
                    {isOnline ? (
                        <img className="" src={cloudOn} alt="cloudOn"/>
                    ) : (
                        <img className="" src={cloudOff} alt="cloudOff"/>
                    )}
                    {isOnline ? (
                        <div
                            className="hidden group-hover:flex transition-all overflow-hidden w-0 group-hover:flex-1 text-sm text-black mx-2">
                            آنلاین
                        </div>
                    ) : (
                        <div
                            className="hidden delay-1000 group-hover:block transition-all overflow-hidden truncate w-full  group-hover:flex-1 text-sm text-[#878787] mx-2">
                            آخرین بروزرسانی {lastUpdate}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
